import React from "react";
import "../CSS_folder/SkillSet.css";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import java from "../skillsIcon/java.png";
import python from "../skillsIcon/Python.png";
import js from "../skillsIcon/js.png";
import reactIcon from "../skillsIcon/react.webp";
import CSharp from "../skillsIcon/cSharp.webp";
import ts from "../skillsIcon/ts.png";
import html from "../skillsIcon/html.png";
import css from "../skillsIcon/css.png";
import mongoDb from "../skillsIcon/mongoDb.png";
import node from "../skillsIcon/node.png";
import django from "../skillsIcon/django.png";
import spring from "../skillsIcon/spring.png";
import aws from "../skillsIcon/aws.png";
import premeire from "../skillsIcon/premeire.png";
import ps from "../skillsIcon/ps.png";
import sql from "../skillsIcon/oracle_sql.png";
import firebase from "../skillsIcon/firebase.png";
import postgres from "../skillsIcon/postgres.png";
import docker from "../skillsIcon/docker.png";
import postman from "../skillsIcon/postman.png";
import {
  Fade,
  Flip,
  Bounce,
  JackInTheBox,
  Rotate,
  Roll,
  Slide,
  Zoom,
} from "react-awesome-reveal";

const SkillSet = () => {
  return (
    <div className="skillsetContainer">
 

      <div id="skills" className="subSkillsetContainer">
        <Fade>
          <div className="skillColumn">
            <div>
              <img className="skillIcon" src={java} alt="Java" />
            </div>
            <div>
              <img className="skillIcon" src={ts} alt="TypeScript" />
            </div>
            <div>
              <img className="skillIcon" src={spring} alt="springboot" />
            </div>
            <div>
              <img className="skillIcon" src={firebase} alt="firebase" />
            </div>
          </div>
        </Fade>
        <Fade delay={500}>
          <div className="skillColumn">
            <div>
              <img className="skillIcon" src={python} alt="Python" />
            </div>
            <div>
              <img className="skillIcon" src={html} alt="HTML" />
            </div>
            <div>
              <img className="skillIcon" src={django} alt="Django" />
            </div>
            <div>
              <img className="skillIcon" src={docker} alt="docker" />
            </div>
          </div>
        </Fade>
        <Fade delay={700}>
          <div className="skillColumn">
            <div>
              <img className="skillIcon" src={js} alt="JavaScript" />
            </div>
            <div>
              <img className="skillIcon" src={css} alt="CSS" />
            </div>
            <div>
              <img className="skillIcon" src={aws} alt="AWS" />
            </div>
            <div>
              <img className="skillIcon" src={postman} alt="postman" />
            </div>
          </div>
        </Fade>
        <Fade delay={900}>
          <div className="skillColumn">
            <div>
              <img className="skillIcon" src={reactIcon} alt="React" />
            </div>
            <div>
              <img className="skillIcon" src={mongoDb} alt="MongoDB" />
            </div>
            <div>
              <img className="skillIcon" src={postgres} alt="postgres" />
            </div>
            <div>
              <img className="skillIcon" src={premeire} alt="premeire" />
            </div>
          </div>
        </Fade>
        <Fade delay={1100}>
          <div className="skillColumn">
            <div>
              <img className="skillIcon" src={CSharp} alt="C#" />
            </div>
            <div>
              <img className="skillIcon" src={node} alt="Node.js" />
            </div>
            <div>
              <img className="skillIcon" src={sql} alt="SQL" />
            </div>
            <div>
              <img className="skillIcon" src={ps} alt="photoshop" />
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default SkillSet;
